import { CircularProgress } from '@mui/material';

export const Loading = () => (
  <div>
    <CircularProgress />
  </div>
);
